import { render } from "./Villages.vue?vue&type=template&id=07cbe01d"
import script from "./Villages.vue?vue&type=script&lang=js"
export * from "./Villages.vue?vue&type=script&lang=js"

import "./Villages.vue?vue&type=style&index=0&id=07cbe01d&lang=scss"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__